var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.horse.horseType == 'pony')?_c('span',[_c('span',[_vm._v(_vm._s(_vm.$t("horses:ponyTypes." + _vm.horse.ponyType)))]),_vm._v(" "),_c(_setup.AppValidationAlert,{attrs:{"check-valid":_setup.isValid,"valid":_vm.$t(
        'horses:appshow.PonyMeasurementStatus.valid.label',
        'Pony measurement valid'
      ),"invalid":_vm.$t(
        'horses:appshow.PonyMeasurementStatus.expired.label',
        'Pony measurement expired'
      )}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }